import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwContext, DwExpressionService, DwFormActionInterceptResult, DwFormActionInterceptor, DwFormActionKeys, DwFormContextMode, DwItemAttribute, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormConfig, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSectionBasePreference, DwSecurityUserService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, areEqual, deepCopy, formatDateTimeFromLocal } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, CheckRideWorkflowAllItems, FlightSchoolApplicantEntity } from '../../../../meta-data/app-meta-data.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { PilexosUser } from '../../../shared/models/pilexos-user.model';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { ExaminerBookingVariableContext } from '../../../booking/models/examiner-booking-variable-context.model';
import { debounceTime, delay, distinctUntilChanged } from 'rxjs/operators';

@DwComponent({
  key: 'school-checkride-search-util',
  name: ' School Checkride Search Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-school-check-ride-search-util',
  templateUrl: './school-check-ride-search-util.component.html',
  styleUrls: ['./school-check-ride-search-util.component.scss']
})
export class SchoolCheckRideSearchUtilComponent extends DwSectionBaseComponent {

  // Logic was moved to the SchoolCheckRideUtil Component to be more efficient.

  // checkRideRequest: CheckRideRequestEntity;

  // originalCheckRideRequest: CheckRideRequestEntity;

  // rebookSetupComplete = false;
  // formApi: DwMetaDataFormApi;
  // applicantDataUpdated: boolean;
  // applicantCheckride: CheckRideRequestEntity;
  // examinerScheduleRechecked: boolean;
  // activeCheckrideChecked: boolean;
  // lastCheckRideRequest: CheckRideRequestEntity;
  // allApplicants: FlightSchoolApplicantEntity[];
  // variableContext: ExaminerBookingVariableContext;
  // lastVariableContext: ExaminerBookingVariableContext;
  // errorMessage: string;
  // showError: boolean;

  // constructor(
  //   dwExpressionService: DwExpressionService,
  //   dwUiConfigRegistryService: DwUiConfigRegistryService,
  //   @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
  //   @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
  //   private dwMetaDataFormStateService: DwMetaDataFormStateService,
  //   private dateTimeUtilService: DateTimeUtilService,
  //   private adminManagerSerice: AdminManagerService,
  //   private schoolRespositoryService: SchoolRepositoryService,
  // ) {
  //   super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

  //   this.formApi = this.dwMetaDataFormStateService.state.formApi;


  //  // this.loadApplicants();
  // }

  // variableChangeCount = 0;
  // setupComponentComplete() {
  //   super.setupComponentComplete();

  //   return;

  //   this.formApi.getFormDataChanges(300)
  //     .subscribe((checkRideRequest: CheckRideRequestEntity) => {
  //       this.checkRideRequest = this.formApi.getFormData<CheckRideRequestEntity>();

  //       this.handleDataUpdate();
  //     });

  //   this.formApi.getVariableContext<ExaminerBookingVariableContext>()
  //     .pipe(debounceTime(300))
  //     .subscribe((context) => {
  //       this.variableContext = this.formApi.getVariableContextValue();

  //       this.variableChangeCount++;

  //       if (this.variableChangeCount - 1 % 10 == 0) {
  //         //console.log('Variable context change count:', this.variableChangeCount, this.variableContext);
  //       }

  //       this.handleDataUpdate();
  //     });

  //   this.variableContext = this.formApi.getVariableContextValue();

  //   this.checkRideRequest = this.formApi.getFormData();
  //   this.handleDataUpdate();
  // }

  // // Used to determine why variable context kept changing every millisecond
  // compare(x: ExaminerBookingVariableContext, y: ExaminerBookingVariableContext): boolean {

  //   if (x && !y || !x && y) {
  //     return true;
  //   }
  //   if (!x && !y) {
  //     return false;
  //   }

  //   var hasChanged = areEqual(x, y);

  //   if (hasChanged) {
  //     //console.log('Variable context changed:', x, y);
  //   }

  //   return hasChanged;
  // }

  // private loadApplicants() {
  //   const pilexosUser = this.adminManagerSerice.getPilexosUser();

  //   this.schoolRespositoryService.getCurrentFlightSchoolApplicants()
  //     .pipe(debounceTime(10))
  //     .subscribe(applicants => {
  //       this.allApplicants = applicants;

  //       this.handleDataUpdate();
  //     });
  // }

  // private handleDataUpdate() {

  //   if (!this.checkRideRequest || !this.variableContext || !this.allApplicants) {
  //     return;
  //   }

  //   // Check if fields have changed
  //   const attrs = AppMetaData.CheckRideRequest.Attributes;

  //   if (!this.hasChanges(this.checkRideRequest, this.lastCheckRideRequest, attrs.FlightSchoolApplicantId) && !this.hasVariableContextChanges()) {
  //     this.lastCheckRideRequest = deepCopy(this.checkRideRequest);
  //     this.lastVariableContext = deepCopy(this.variableContext);

  //     return;
  //   }

  //   this.lastCheckRideRequest = deepCopy(this.checkRideRequest);
  //   this.lastVariableContext = deepCopy(this.variableContext);

  //   let applicant = this.allApplicants.find(a => a.FlightSchoolApplicantId === this.checkRideRequest.FlightSchoolApplicantId);

  //   if (this.variableContext?.BookMultiple && this.checkRideRequest.CheckRideWorkflowId == CheckRideWorkflowAllItems.SchoolWorkflow) {

  //     if (!this.variableContext?.Applicants) {
  //       return;
  //     }

  //     const applicantIds = this.variableContext.Applicants.split(',').map(id => parseInt(id, 10));

  //     const applicants = this.allApplicants.filter(a => applicantIds.includes(a.FlightSchoolApplicantId));

  //     if (applicantIds.length === 0) {
  //       return;
  //     }
  //     const result = this.validateApplicants(applicants);

  //     this.errorMessage = result.message;
  //     this.showError = !result.isValid;

  //     if (!result.isValid) {
  //       return;
  //     }

  //     if (result.applicantRef) {
  //       applicant = result.applicantRef;
  //     } else {
  //       applicant = applicants[0];
  //     }
  //   }

  //   if (applicant) {

  //     const checkrideUpdate: Partial<CheckRideRequestEntity> = {
  //       CheckRideGroupId: applicant.CheckRideGroupId,
  //       CheckRideTypeId: applicant.CheckRideTypeId,
  //       CheckRideTestTypeId: applicant.CheckRideTestTypeId,
  //       FlightSchoolApplicantId: applicant.FlightSchoolApplicantId,
  //       //PreferredDateTime: applicant.ExpectedCheckrideDateTime,
  //     };

  //     if (applicant.FlightSchoolApplicantBranch?.length > 0) {
  //       const location = applicant.FlightSchoolApplicantBranch[0];

  //       if (location?.FlightSchoolBranch?.MainAirportId) {
  //         checkrideUpdate.PreferredAirportId = location.FlightSchoolBranch.MainAirportId;
  //       }
  //     }

  //     if (applicant.FlightSchoolBranch?.MainAirportId) {
  //       checkrideUpdate.PreferredAirportId = applicant.FlightSchoolBranch.MainAirportId;
  //     }

  //     let noChanges = (this.checkRideRequest?.CheckRideGroupId == applicant.CheckRideGroupId &&
  //       this.checkRideRequest?.CheckRideTypeId == applicant.CheckRideTypeId &&
  //       this.checkRideRequest?.CheckRideTestTypeId == applicant.CheckRideTestTypeId &&
  //       //this.checkRideRequest?.PreferredDateTime == applicant.ExpectedCheckrideDateTime &&
  //       this.checkRideRequest?.PreferredAirportId == checkrideUpdate?.PreferredAirportId &&
  //       this.checkRideRequest?.FlightSchoolApplicantId == checkrideUpdate?.FlightSchoolApplicantId
  //     );

  //     if (noChanges) {
  //       return;
  //     }

  //     setTimeout(() => {
  //       this.formApi.patchFormData(checkrideUpdate);
  //     }, 100);
  //   }
  // }

  // validateApplicants(applicants: FlightSchoolApplicantEntity[]): { isValid: boolean, applicantRef?: FlightSchoolApplicantEntity, message?: string } {
  //   // Ensure all applicants have the same CheckRideGroupId
  //   const result: { isValid: boolean, applicantRef?: FlightSchoolApplicantEntity, message?: string } = {
  //     isValid: true,
  //     applicantRef: null,
  //   };

  //   // Get the first applicant that has a CheckRideTypeId
  //   result.applicantRef = applicants.find(a => a.CheckRideTypeId);

  //   if (!result.applicantRef) {
  //     return result;
  //   }

  //   const messages: string[] = [];

  //   for (const applicant of applicants) {
  //     if (applicant.CheckRideTypeId && applicant.CheckRideTypeId !== result.applicantRef.CheckRideTypeId) {
  //       messages.push(`Applicant ${applicant.ApplicantName} is for ${applicant.CheckRideGroupIdDisplay} - ${applicant.CheckRideTypeIdDisplay}`);
  //     }
  //   }

  //   if (messages.length > 0) {

  //     messages.unshift(`Applicant ${result.applicantRef.ApplicantName} is for ${result.applicantRef.CheckRideGroupIdDisplay} - ${result.applicantRef.CheckRideTypeIdDisplay}`);
  //     const list = '<ul>' + messages.map(m => `<li>${m}</li>`).join('') + '</ul>'

  //     result.message = `All applicants must be for the same Grade & Category! <br> ${list}`;
  //     result.isValid = false;
  //   }

  //   return result;
  // }

  // hasVariableContextChanges(): boolean {
  //   if (this.variableContext?.BookMultiple != this.lastVariableContext?.BookMultiple ||
  //     (this.variableContext?.BookMultiple && this.variableContext?.Applicants != this.lastVariableContext?.Applicants)) {
  //     return true;
  //   }

  //   return false;
  // }

  // hasChanges(current: any, last: any, ...attrs: DwItemAttribute[]): boolean {
  //   if (!current) {
  //     return false;
  //   }

  //   if (!last) {
  //     return true;
  //   }

  //   for (const attr of attrs) {
  //     if (current[attr.fieldName] !== last[attr.fieldName]) {
  //       return true;
  //     }
  //   }

  //   return false;
  // }


}
